import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Popconfirm } from 'antd'
import { classNames } from 'utils/utils'
import styled from '@emotion/styled'
import { Icon } from 'components/patterns'
import 'styles/ChecPopconfirm.css'

export const ErrorIcon = styled(Icon)`
  margin-right: 10px;
  margin-top: 2px;
  flex-shrink: 0;
  &&& {
    height: 18px;
    width: 20px;
  }
`
export default class ChecPopconfirm extends Component {
  state = {
    visible: false,
  }

  static propTypes = {
    showConfirm: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onConfirm: PropTypes.func.isRequired,
    cancelType: PropTypes.string,
    className: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  }

  static defaultProps = {
    showConfirm: true,
    className: null,
    cancelType: null,
  }

  confirm = () => {
    this.setState({ visible: false })
    this.props.onConfirm()
  }

  handleVisibleChange = (visible) => {
    const { showConfirm } = this.props

    if (!visible) {
      this.setState({ visible })
      return
    }

    if (!showConfirm) {
      this.confirm()
    } else {
      this.setState({ visible })
    }
  }

  render() {
    const {
      cancelType,
      className,
      overlayClassName: extraOverlayClass,
    } = this.props
    const popConfirmClassNames = classNames('chec-popconfirm', {
      [`cancel-${cancelType}`]: cancelType,
      [extraOverlayClass]: extraOverlayClass,
    })

    return (
      <Popconfirm
        {...this.props}
        className={className}
        overlayClassName={popConfirmClassNames}
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        onConfirm={this.confirm}
        icon={
          <ErrorIcon
            icon="alert_exclamation_triangle_solid"
            fill="errorAccent"
          />
        }
      >
        {this.props.children}
      </Popconfirm>
    )
  }
}
